import * as React from 'react';
import { connect } from 'react-redux';
import { Api } from '../../../typings/api';
import { StoreState } from '../../../reducers';
import VideoPlayer from '../../../components/VideoPlayer';
import AudioPlayer from '../../../components/AudioPlayer';
import { GalleryInfosState } from '../../Gallery/reducer';
import { StyledTheaterContent, Image, SvgIcon } from './styles';
import Utils from '../../../utils';
import UrlUtils from '../../../utils/url';
import DriveItemUtils from '../../../utils/driveItem';
import UserAgentUtils from '../../../utils/userAgent';
import { DownloadManagerState } from '../../DownloadManager/reducer';
import DownloadManagerUtils from '../../../utils/downloadManager';
import { OfflineManagerState } from '../../OfflineManager/reducer';

interface TheaterContentProps {
	driveItem?: Api.DriveItem;
	resolutions: { [k: string]: Api.ResolutionGroup };
	galleryInfos: GalleryInfosState;
	downloadManager: DownloadManagerState;
	offlineManager: OfflineManagerState;
}

const TheaterContent = (props: TheaterContentProps) => {
	const { driveItem, resolutions, galleryInfos, downloadManager, offlineManager: { thumbMap } } = props;
	const galleryConfig = galleryInfos.config;
	const isOnline = UserAgentUtils.isOnline();

	let isDownloaded = false;
	if (driveItem !== undefined) {
		isDownloaded = DownloadManagerUtils.isItemDownloaded(downloadManager, driveItem.id);
	}

	let element;
	if (driveItem) {
		let fileUrl;

		if (isOnline || isDownloaded) {
			if (isDownloaded) {
				fileUrl = `${Utils.getPersistentDownloadsFolder()}/${DriveItemUtils.getDownloadedFileName(driveItem)}`;
			} else {
				fileUrl = UrlUtils.getItemOriginalFileUrl(galleryConfig, driveItem.originalFile);
			}

			switch (driveItem.type) {
				case Api.DriveItemType.Movie:
					element = <VideoPlayer url={fileUrl} />;
					break;
				case Api.DriveItemType.Image:
					const imgSrc = DriveItemUtils.getTheaterImage(driveItem, galleryInfos.config, resolutions);
					element = <Image src={isDownloaded ? fileUrl : imgSrc} />;
					break;
				case Api.DriveItemType.Sound:
					element = <AudioPlayer url={fileUrl} />;
					break;
				default:
					if (DriveItemUtils.hasIcon(driveItem)) {
						const thumbSrc = DriveItemUtils.getThumbnail(driveItem, galleryInfos.config, resolutions, true);
						element = <Image src={thumbSrc} />;
					} else {
						const svgIcon = DriveItemUtils.getDefaultThumbnail(driveItem);
						element = <SvgIcon><use xlinkHref={`#svgicon-${svgIcon}`} /></SvgIcon>;
					}
					break;
			}
		} else {
			if (DriveItemUtils.hasIcon(driveItem)) {
				fileUrl = Utils.getDeviceThumbnailPath(galleryInfos.config, thumbMap, driveItem, resolutions, false);
				element = <Image src={fileUrl} />;
			} else {
				const svgIcon = DriveItemUtils.getDefaultThumbnail(driveItem);
				element = <SvgIcon><use xlinkHref={`#svgicon-${svgIcon}`} /></SvgIcon>;
			}
		}
	}

	return (
		<StyledTheaterContent>{element}</StyledTheaterContent>
	);
};

const mapStateToProps = (state: StoreState) => {
	const { downloadManager, offlineManager } = state;
	return { downloadManager, offlineManager };
};

export default connect(mapStateToProps)(TheaterContent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Theater/Content/index.tsx